(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 36393:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(20014);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_route_ServerResponseContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14101);




var Redirect = function(param) {
    var to = param.to;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_lib_route_ServerResponseContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Consumer */ .Z.Consumer, {
        children: function(response) {
            if (response) {
                response.writeHead(303, {
                    Location: to
                });
                response.end();
                return null;
            }
            if (true) {
                next_router__WEBPACK_IMPORTED_MODULE_1___default().replace(to);
            }
            return null;
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Redirect);


/***/ }),

/***/ 20014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./lib/queries/GetIsOnboardingActive.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetIsOnboardingActive {\n    getIsOnboardingActive\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GetIsOnboardingActive = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./lib/queries/GetOnboarding.ts

function GetOnboarding_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Onboarding($userId: ObjectId!) {\n    onboarding(userId: $userId) {\n      _id\n      workingFor\n      processStatus\n      country\n      state\n      city\n      governmentId\n      vendorName\n      vendorWebsite\n      linkedInUrl\n      twitterUrl\n      facebookUrl\n      workplaceName\n      workplaceWebsite\n      whyYouWantToJoin\n    }\n  }\n"
    ]);
    GetOnboarding_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GetOnboarding = ((0,lib/* gql */.Ps)(GetOnboarding_templateObject()));

// EXTERNAL MODULE: ./lib/route/Redirect.tsx
var Redirect = __webpack_require__(47116);
// EXTERNAL MODULE: ./pages/landingPage.tsx + 38 modules
var landingPage = __webpack_require__(59201);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
;// CONCATENATED MODULE: ./src/components/onboarding/isOnboarding.ts

function isOnboarding(userOnboarding, globalOnboardingToggle) {
    if (!userOnboarding) {
        return false;
    }
    if (userOnboarding && userOnboarding.processStatus === types/* IProcessStatusType.Required */.w1.Required && globalOnboardingToggle) {
        return true;
    }
    return false;
};

;// CONCATENATED MODULE: ./src/components/IndexPage.tsx










function IndexPage(param) {
    var userId = param.userId;
    var ref = (0,useQuery/* useQuery */.a)(GetIsOnboardingActive, {
        fetchPolicy: "network-only"
    }), data = ref.data, loading = ref.loading;
    var ref1 = (0,useQuery/* useQuery */.a)(GetOnboarding, {
        variables: {
            userId: userId
        },
        fetchPolicy: "network-only"
    }), userOnboarding = ref1.data, userOnboardingLoading = ref1.loading;
    if (loading || userOnboardingLoading) {
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarLayout/* default */.Z, {
            pb: 0,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                justify: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
            })
        });
    }
    if (userOnboarding && data && isOnboarding(userOnboarding.onboarding, data.getIsOnboardingActive)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
            to: "/onboarding"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landingPage["default"], {});
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
;// CONCATENATED MODULE: ./pages/index.tsx






function Index() {
    var user = (0,Auth/* useSelfie */.yD)();
    var router = (0,next_router.useRouter)();
    var previewToken = router.query.preview;
    var isHomePagePreview = typeof previewToken !== "undefined" && previewToken.length > 0;
    if (!user || isHomePagePreview) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landingPage["default"], {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndexPage, {
        userId: user._id
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,8201,5522,1744,9932,9201,9774,2888,179], function() { return __webpack_exec__(36393); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);